import React from 'react';
import { Tooltip } from "@mui/material";

const UrgentActionTile = ({ title, tooltip, count, onClick, isActive }) => (
  <Tooltip title={tooltip}>
    <div 
      className={`flex items-center justify-between p-2 rounded-md transition-colors ${
        isActive ? 'cursor-pointer hover:bg-gray-100' : 'cursor-default'
      }`}
      onClick={isActive ? onClick : undefined}
    >
      <span className="font-medium text-green-700">{title}</span>
      <span className="text-black font-semibold">{count}</span>
    </div>
  </Tooltip>
);

export default UrgentActionTile;
